// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container_AxGYr","tooltip":"Tooltip_tooltip_TP1hg"};